import * as core from '../../../../../../../core'

import { query } from './trends-stacked.query'

export const RESOURCE = {
  payload: {
    alias: 'rp.trends.widgets.stacked-bar-chart',
    description:
      'Stacked bar chart for trends page using hardcoded dates and subqueries -- for demo purposes.',
    name: 'RP Trends - Stacked Bar Chart',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
